import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { Plan, ProductType } from '@/components/Billing/billing-types';
import { capitalizeFirstWord } from '@/utils/language-service';

export default /*#__PURE__*/_defineComponent({
  __name: 'FreeBetaPlanIndicator',
  props: {
    plan: null,
    productType: null
  },
  setup(__props: any) {

const props = __props as {
	plan: Plan;
	productType: ProductType;
}


const readableProductType = computed(() => capitalizeFirstWord(props.productType.replace('product-', '').replaceAll('-', ' ')));

return { __sfc: true,props, readableProductType }
}

})